const loggingMiddleware = state => next => action => {
  console.log("Logging state: ", state.getState());
  console.log("Triggered by: ", action.type);
  console.log("Action payload: ", action.payload);
  next(action);
};

export default loggingMiddleware;
